/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FinanceSettingsDTO { 
    roundingScheme?: FinanceSettingsDTO.RoundingSchemeEnum;
    roundingPrecision?: number;
}
export namespace FinanceSettingsDTO {
    export type RoundingSchemeEnum = 0 | 1;
    export const RoundingSchemeEnum = {
        NUMBER_0: 0 as RoundingSchemeEnum,
        NUMBER_1: 1 as RoundingSchemeEnum
    };
}